import "./calendar.scss"
import { useState, useEffect, useCallback } from "react"
import moment from "moment"
import api from "api"
import { Link, useParams, useHistory } from 'react-router-dom';
import Item from "components/calendar/item"
import { RootState } from "types"
import { useDispatch, useSelector } from "react-redux"
import Ticket from "components/ticket"
import { actions } from 'redux/reducers';
import NewItemModal from "components/calendar/new-item-modal"

function Calendar() {
    const params: any = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: RootState) => state.user)
    const [date, setDate] = useState<Date>(new Date())
    const [menuOpen, setMenuOpen] = useState(false)
    const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    const state = useSelector((state: RootState) => state);
    const [calendar, setCalendar] = useState<any>(null);
    const [newItemModalOpen, setNewItemModalOpen] = useState(false)
    const [shared, setShared] = useState(true);
    const [showEvents, setShowEvents] = useState(true);
    const [showTickets, setShowTickets] = useState(true);
    const [selectedDay, setSelectedDay] = useState(0);

    const nextMonth = () => {
        setDate(new Date(moment(date).add(1, "M").toString()))
    }

    const prevMonth = () => {
        setDate(new Date(moment(date).subtract(1, "M").toString()))
    }

    const openItem = (id: number) => {
        if (params.itemId || params.ticketId) {
            history.replace(`/client/${params.clientId}/calendar/item/${id}`);
        } else {
            history.push(`/client/${params.clientId}/calendar/item/${id}`);
        }
    }

    const openTicket = (id: number) => {
        if (params.ticketId || params.itemId) {
            history.replace(`/client/${params.clientId}/calendar/ticket/${id}`);
        } else {
            history.push(`/client/${params.clientId}/calendar/ticket/${id}`);
        }
    }

    const openNewEventModel = (day: number) => {
        setSelectedDay(day);
        setNewItemModalOpen(true);
    }

    const deleteTicket = (id: number) => {
        let deleteTicket = window.confirm(`Are you sure you want to delete this ticket?`);
        if (deleteTicket) {
            api.ticket.delete(id, user.Id).then(() => {
                history.goBack();
                getData();
            });
        }
    }

    const refresh = () => {
        getData();
    }

    const getData = useCallback(() => {
        const monthStart = moment(date).startOf("M")
        const monthEnd = moment(date).endOf("M")
        const startDate = moment(monthStart).startOf("W")
        const endDate = moment(monthEnd).endOf("W")
        let array: any = []
        const search = window.location.search; // could be '?foo=bar'
        const searchParams = new URLSearchParams(search);
        const boardId = searchParams.get('boardId'); // bar

        if (!boardId) {
            api.calendar.getAll(params.clientId, new Date(monthStart.toString()), new Date(monthEnd.add(1, "d").toString())).then((data) => {
                for (let i = startDate; i.isBefore(endDate); i.add(1, "d")) {
                    const events = data.Events.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
                        return {
                            ...x,
                            Type: "Event",
                        }
                    })
                    const tickets = data.Tickets.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
                        return {
                            ...x,
                            Type: "Ticket",
                            IsShared: true
                        }
                    })

                    array.push({
                        key: i.toString(),
                        data: events.concat(tickets),
                    })
                }
                dispatch(actions.calendar.set(array));
            })
        }
        else {
            api.calendar.getAllForBoard(params.clientId, Number(boardId), new Date(monthStart.toString()), new Date(monthEnd.add(1, "d").toString())).then((data) => {
                for (let i = startDate; i.isBefore(endDate); i.add(1, "d")) {
                    const events = data.Events.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
                        return {
                            ...x,
                            Type: "Event",
                        }
                    })
                    const tickets = data.Tickets.filter((x: any) => moment(x.DueDate).format("DD MMM YYYY") === i.format("DD MMM YYYY")).map((x: any) => {
                        return {
                            ...x,
                            Type: "Ticket",
                            IsShared: true
                        }
                    })

                    array.push({
                        key: i.toString(),
                        data: events.concat(tickets),
                    })
                }
                dispatch(actions.calendar.set(array));
            })
        }
    }, [date, params.clientId, dispatch])

    useEffect(() => {
        let data = [...state.calendar];

        if (!shared) {
            data = data.map((x: any) => {
                return {
                    ...x,
                    data: x.data.filter((y: any) => y.AssigneeId === user?.Id || y.ContactId === user?.Id),
                }
            })
        } else {
            data = data.map((x: any) => {
                return {
                    ...x,
                    data: x.data.filter((y: any) => y.IsShared || (y.AssigneeId === user?.Id || y.ContactId === user?.Id)),
                }
            })
        }

        if (!showEvents) {
            data = data.map((x: any) => {
                return {
                    ...x,
                    data: x.data.filter((y: any) => y.Type !== "Event"),
                }
            })
        }

        if (!showTickets) {
            data = data.map((x: any) => {
                return {
                    ...x,
                    data: x.data.filter((y: any) => y.Type !== "Ticket"),
                }
            })
        }

        setCalendar(data)
    }, [state.calendar, shared, showEvents, showTickets, user])

    useEffect(() => {
        getData()
    }, [getData])

    return (
        <>
            <div className="calendar">
                <div className="calendar-header">
                    <Link to={`/client/${params.clientId}/dashboard`}>
                        <i className="fas fa-home"></i>
                    </Link>
                    <p>Calendar</p>
                    <i className="far fa-angle-left" onClick={prevMonth}></i>
                    <span id="calendar-date">{moment(date).format("MMMM YYYY")}</span>
                    <i className="far fa-angle-right" onClick={nextMonth}></i>
                    <i className="fas fa-ellipsis-h" onClick={() => setMenuOpen(!menuOpen)}></i>
                    <div id="calendar-menu" className={menuOpen ? "open" : ""}>
                        <p>Show</p>
                        <div className="input-group">
                            <input type="checkbox" id="check-events" checked={showEvents} onChange={() => setShowEvents(!showEvents)} />
                            <label htmlFor="check-events">Events</label>
                        </div>
                        <div className="input-group">
                            <input type="checkbox" id="check-tickets" checked={showTickets} onChange={() => setShowTickets(!showTickets)} />
                            <label htmlFor="check-tickets">Tickets</label>
                        </div>
                        <hr />
                        <div className="input-group radio">
                            <input type="radio" id="radio-shared" name="radio-calendar" checked={shared} onChange={() => setShared(true)} />
                            <label htmlFor="radio-shared">Shared</label>
                            <input type="radio" id="radio-personal" name="radio-calendar" checked={!shared} onChange={() => setShared(false)} />
                            <label htmlFor="radio-personal">Personal</label>
                        </div>
                    </div>
                </div>
                <div className="calendar-body">
                    <div className="calendar-weekdays">
                        {dayNames.map((day) => (
                            <div className="calendar-weekday" key={day}>
                                {day}
                            </div>
                        ))}
                    </div>
                    <div className="calendar-days">
                        {calendar?.map((x: any, i: number) => {
                            return (
                                <div className="calendar-day" key={i}>
                                    <span className="day">{moment(new Date(x.key)).format("D")}</span>
                                    <i className="fal fa-plus" onClick={() => openNewEventModel(parseInt(moment(new Date(x.key)).format("D")))}></i>
                                    <div className="calendar-day-items">
                                        {x.data.map((item: any, i: number) =>
                                            item.Type === "Event" ? (
                                                <div className="event" onClick={() => openItem(item.Id)} title={item.Title} key={i}>
                                                    {item.Title}
                                                </div>
                                            ) : (
                                                <div className="ticket" onClick={() => openTicket(item.Id)} title={item.Heading} key={i}>
                                                    {item.Heading}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <Ticket deleteTicket={deleteTicket} refresh={refresh}/>
            <Item
                date={date}
            />
            <NewItemModal
                open={newItemModalOpen}
                setOpen={setNewItemModalOpen}
                id="calendar-new-item-modal"
                date={date}
                day={selectedDay}
            />
        </>
    )
}

export default Calendar
